import _regeneratorRuntime from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import dateformat from 'dateformat';

var debug = require('debug')('crate:view:comments');
/**
 * This class is for managing the comments for quill
 */


export var Comments =
/*#__PURE__*/
function () {
  /**
   * [constructor description]
   * @param  {[type]} editorContainerID [description]
   * @return {[type]}                   [description]
   */
  function Comments() {
    _classCallCheck(this, Comments);

    // Selectors
    this._commentCallback = {};
    this.commentAddClick = this.commentAddClick.bind(this);
    this.commentsClick = this.commentsClick.bind(this);
  }

  _createClass(Comments, [{
    key: "init",
    value: function init(editor) {
      this._editor = editor;
      this._authorId = this._editor._document.uid;
      this._editorContainerID = this._editor._editorContainerID;
      this._viewEditor = this._editor.viewEditor;
      this._markerManager = this._editor._MarkerViewManager;
      this.setSelectors();
      return this;
    }
  }, {
    key: "addAuthorInformation",
    value: function addAuthorInformation() {
      var commentOpt = this._viewEditor.options.modules.comment;
      commentOpt.commentAuthorId = this._authorId;
      commentOpt.commentAddOn = this._markerManager.getMarker(this._authorId).animal;
      commentOpt.color = this._markerManager.getMarker(this._authorId).colorRGB;
      return this;
    }
  }, {
    key: "setSelectors",
    value: function setSelectors() {
      this._inputCommentModel = $("#".concat(this._editorContainerID, " #inputCommentModal"));
      this._commentsSelector = $("#".concat(this._editorContainerID, " #comments"));
      this._ql_editorSelector = $("#".concat(this._editorContainerID, " .ql-editor"));
      this._editorSelector = $("#".concat(this._editorContainerID, " .editor"));
      this._commentInputSelector = $("#".concat(this._editorContainerID, " #commentInput"));
    }
  }, {
    key: "commentAddClick",
    value: function commentAddClick(cb, self) {
      console.log('commentAddClick is clicked');
      this._commentCallback = cb.bind(self);

      this._inputCommentModel.modal('show');
    }
  }, {
    key: "getCurrentTimestamp",
    value: function getCurrentTimestamp() {
      return new Promise(function (resolve, reject) {
        var currentTimestamp = Math.round(new Date().getTime() / 1000); // call from server

        resolve(currentTimestamp);
      });
    }
  }, {
    key: "commentsClick",
    value: function commentsClick() {
      if (this._commentsSelector.is(':visible')) {
        if (this._ql_editorSelector.hasClass('ql-comments')) {
          this._ql_editorSelector.removeClass('ql-comments');
        }

        this._commentsSelector.hide();

        this._commentsSelector.css('width', '0%');

        this._editorSelector.css('width', '100%');
      } else {
        this._commentsSelector.addClass('comment');

        if (!this._editorSelector.hasClass('ql-comments')) {
          this._editorSelector.addClass('ql-comments');
        }

        this._commentsSelector.css('width', '30%');

        this._editorSelector.css('width', '70%');

        this._commentsSelector.show();
      }
    }
  }, {
    key: "addCommentToList",
    value: function () {
      var _addCommentToList = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(_ref) {
        var comment, currentTimestamp, authorId, marker, date, divId, opts, cmtBox;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                comment = _ref.comment, currentTimestamp = _ref.currentTimestamp, authorId = _ref.authorId;
                marker = this._markerManager.addMarker(authorId, false, {
                  lifetime: -1
                });
                date = dateFormat(new Date(), 'dddd, mmmm dS, yyyy, h:MM:ss TT');
                divId = 'ql-comment-' + authorId + '-' + currentTimestamp;
                opts = {
                  id: divId,
                  date: date,
                  pseudoName: marker.pseudoName,
                  colorRGB: marker.colorRGB,
                  comment: comment,
                  iconURL: "./icons/".concat(marker.animal, ".png")
                };
                cmtBox = this.getCommentBoxDiv(opts);

                this._commentsSelector.append(cmtBox);

                this.addFocusEffects(divId);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function addCommentToList(_x) {
        return _addCommentToList.apply(this, arguments);
      };
    }()
  }, {
    key: "getCommentBoxDiv",
    value: function getCommentBoxDiv(opts) {
      var cmtbox = $("<div class='comment-box ".concat(opts.id, " row' id='comment-box-").concat(opts.id, "' tabindex=\"1\" title='").concat(opts.date, "'>\n      <div class='comment-head row'>\n        <div id=\"").concat(opts.id, "\"style=\"background-color:").concat(opts.colorRGB, ";width: 40px;\" ><img class=\"imageuser\" src=\"").concat(opts.iconURL, "\" alt=\"").concat(opts.pseudoName, "\"></div>\n    \n        <div class='comment-details'>\n          <div class='comment-author'>").concat(opts.pseudoName, "</div>\n        </div>\n      </div>\n      <div class='comment-body row' >").concat(opts.comment, "</div>\n  \n    </div>"));
      return cmtbox;
    }
  }, {
    key: "addFocusEffects",
    value: function addFocusEffects(divId) {
      var _this = this;

      console.log('#comment-box-' + divId);
      $('#comment-box-' + divId).focusin(function () {
        _this.commentBoxFocus(divId, 'in');
      });
      $('#comment-box-' + divId).focusout(function () {
        _this.commentBoxFocus(divId, 'out');
      });
    }
  }, {
    key: "saveComment",
    value: function () {
      var _saveComment = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var comment, currentTimestamp;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                comment = this._commentInputSelector.val();

                this._commentInputSelector.val('');

                _context2.next = 4;
                return this.getCurrentTimestamp();

              case 4:
                currentTimestamp = _context2.sent;
                _context2.next = 7;
                return this.addCommentToList({
                  comment: comment,
                  currentTimestamp: currentTimestamp,
                  authorId: this._authorId
                });

              case 7:
                this._commentCallback({
                  comment: comment,
                  currentTimestamp: currentTimestamp
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function saveComment() {
        return _saveComment.apply(this, arguments);
      };
    }()
  }, {
    key: "commentBoxFocus",
    value: function commentBoxFocus(id, type) {
      console.log(type, '.ql-comments #' + id);

      if (type !== 'out') {
        $('.ql-comments #' + id).addClass('commentFocus');

        this._commentsSelector.find('.' + id).css('border-color', 'red');
      } else {
        $('.ql-comments #' + id).removeClass('commentFocus');

        this._commentsSelector.find('.comment-box').css('border-color', '#F0F0F0');
      }
    }
    /**
     * UpdateComments This function to extract the comments form the editor and show them in #comments
     */

  }, {
    key: "UpdateComments",
    value: function UpdateComments() {
      var _this2 = this;

      debug('cmments updated'); // clear comments

      this.clearComments(); // for each insert check att if it contains the author then insert comment

      this.viewEditor.editor.delta.ops.forEach(function (op) {
        if (op.insert && op.attributes && op.attributes.commentAuthor) {
          var authorId = op.attributes.commentAuthor;
          var comment = op.attributes.comment;
          var currentTimestamp = op.attributes.commentTimestamp;

          _this2.addCommentToList({
            comment: comment,
            currentTimestamp: currentTimestamp,
            authorId: authorId
          });
        }
      });
    }
  }, {
    key: "clearComments",
    value: function clearComments() {
      jQuery("#".concat(this._editorContainerID, " #comments")).empty();
    }
  }, {
    key: "viewEditor",
    get: function get() {
      return this._viewEditor;
    },
    set: function set(Editor) {
      this._viewEditor = Editor;
    }
  }]);

  return Comments;
}();